import {Platform, View, ViewStyle} from 'react-native';

import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {useMutation} from 'react-query';
import {setDownloadingProgress} from '../../../store/slices/fs';
import {downloadFileById, getProjectMedia} from '../../../api/media';
import {Button, Text} from 'react-native-paper';
export function EditorLoader({
  width,
  height,
  queryData,
  isAudioMissing,
  isVideoMissing,
  refetch,
}: {
  width: number;
  height: number;
  queryData: Awaited<ReturnType<typeof getProjectMedia>>;
  isAudioMissing: boolean;
  isVideoMissing: boolean;
  refetch: () => Promise<void>;
}) {
  const dispatch = useAppDispatch();
  const platformWidth = Platform.select({
    web: 'auto',
    ios: width,
    android: width,
  });
  const statusMessageStyle: ViewStyle = {
    display: 'flex',
    width: platformWidth,
    height,
    flexDirection: 'column',
    alignContent: 'center',
    alignItems: 'center',
    gap: 20,
    paddingTop: height / 2 - 50,
  };
  let fileStatusMessage = 'Media is missing';
  let fileButtonMessage = 'Download Media';

  const onDownloadMediaMutation = useMutation(
    async (mediaId: string, folderId: string) => {
      console.info('onDownloadMediaPress', mediaId);
      const itemId = mediaId;
      dispatch(setDownloadingProgress({itemId, progress: 0.001}));
      try {
        await downloadFileById(
          mediaId,
          folderId,
          progress =>
            dispatch(
              setDownloadingProgress({
                itemId,
                progress,
              }),
            ),
          () => refetch(),
        );
      } catch (err) {
        console.error(err);
      }
    },
  );
  const missingMedia = isAudioMissing
    ? queryData.audioLayer?.activeMedia
    : queryData.activeMedia;
  const downloadProgress = useAppSelector(
    state =>
      missingMedia?.id &&
      state.fs.downloadingProgress[missingMedia?.id],
  );
  const onDownloadMediaPress = onDownloadMediaMutation.mutateAsync;
  if (onDownloadMediaMutation.isLoading || downloadProgress) {
    fileButtonMessage = `Downloading Media`;
  }
  return (
    <View style={statusMessageStyle}>
      <Text>{fileStatusMessage}</Text>
      <Button
        mode="outlined"
        loading={
          onDownloadMediaMutation.isLoading || downloadProgress
        }
        disabled={
          onDownloadMediaMutation.isLoading || downloadProgress
        }
        onPress={() =>
          onDownloadMediaPress(
            missingMedia?.id,
            missingMedia?.folderId,
          )
        }>
        {fileButtonMessage}
      </Button>
    </View>
  );
}
